import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback
} from "react";
import api from "../../../api.js";
const MyOrganizationsContext = createContext();
export function MyOrganizationsProvider({ children }) {
  const [organizations, setOrganizations] = useState([]);
  const [currentOrganization, setCurrentOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchOrganizations = useCallback(async () => {
    setLoading(true);
    try {
      const { organization: id, organizations: organizations2 } = await api.getUser();
      setOrganizations(organizations2);
      const currentOrg = organizations2.find((org) => org.id === id);
      setCurrentOrganization(currentOrg || null);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);
  return /* @__PURE__ */ React.createElement(
    MyOrganizationsContext.Provider,
    {
      value: {
        organizations,
        currentOrganization,
        fetchOrganizations,
        loading
      }
    },
    children
  );
}
export const useMyOrganizations = () => useContext(MyOrganizationsContext);
